import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import translations from './en/index'

export const resources = {
  en: {
    translations,
  },
} as const

i18n.use(initReactI18next).init({
  lng: 'en',
  ns: ['translations'],
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
  },
  resources,
  pluralSeparator: '_',
})
